module.exports = __webpack_public_path__ + "static/media/nc.9aee7ce8.svg";